import { render, staticRenderFns } from "./MaterialtoList.vue?vue&type=template&id=5b66ed3f&scoped=true&"
import script from "./MaterialtoList.vue?vue&type=script&lang=js&"
export * from "./MaterialtoList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialtoList.vue?vue&type=style&index=0&id=5b66ed3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66ed3f",
  null
  
)

export default component.exports